<button mat-raised-button color="primary" class="custom-button" type="button" (click)="saveToDirectory()">
  <mat-icon>save_alt</mat-icon>
  {{ 'dataManagement.dataExchangeRequests.actions.saveToDirectory' | transloco }}
</button>
